import { defineMessage } from 'services/localization';

export const messages = {
    tooltip: defineMessage('your_trusted_device_wil_able_fa_on_your_account'),
};
